module.exports = __webpack_public_path__ + "img/4-1_02.2a2d3ff5.jpg";